import SJButton from '@/components/SJButton'
import { useCallback, useEffect, useState } from 'react'
import { useInterval } from 'ahooks'
import { getRegistrationGradeInfo } from '@/services/accredit'
import { GradeRes } from '@/services/types/accredit'
import { useLocation, useNavigate } from 'react-router-dom'
import accredit from '@/stores/accredit'
import { observer } from 'mobx-react'
import SJSpace from '@/components/SJSpace'
import SJCheckbox from '@/components/SJCheckbox'
import './index.less'

type State = {
  from?: string
  grade?: string
}
const RegistrationNotice = () => {
  document.title = '评测须知'
  const navigate = useNavigate()
  const { state } = useLocation() as { state: State }
  const { from = '', grade = '16' } = state
  const [checked, setChecked] = useState(false)
  const onCheckChange = (e: any) => {
    setChecked(e)
  }

  const fetchData = useCallback(async () => {
    try {
      const res = (await getRegistrationGradeInfo({ grade: Number(grade) })) as unknown as GradeRes
      accredit.applicant_fee = res.fee
      accredit.applicant_code = res.project_code
    } catch (error) {}
  }, [grade])

  useEffect(() => {
    from !== 'result' && fetchData()
  }, [from, fetchData])

  // 倒计时
  const [second, setSecond] = useState(3) // 倒计时 总时间
  const [interval, setInterval] = useState<number | undefined>(1000) // 倒计时 频率
  const [disabled, setDisabled] = useState(true)
  const [intervalText, setIntervalText] = useState(`下一步(${second}s)`)
  useInterval(() => {
    if (second === 1) {
      setSecond(0)
      setInterval(undefined)
      setIntervalText(`下一步`)
      setDisabled(false)
      return
    }
    setSecond(second - 1)
    setIntervalText(`下一步(${second - 1}s)`)
    return () => {
      setInterval(undefined)
    }
  }, interval)

  const handleNext = () => {
    if (second === 0) {
      // Taro.navigateTo({
      //   url: '/packageAccredit/pages/step1/index',
      // })
      navigate('/registration/step1')
    }
  }

  return (
    <div className="page registration-notice">
      <div className="main">
        <SJSpace height={40} />
        <div className="h1">{grade}级评测须知</div>
        <div className="section">
          <div className="h3">1.参加{grade}级在线评测要求</div>
          <div className="p">必须是元萝卜上的已注册棋手</div>
        </div>
        <div className="section">
          <div className="h3">2. 评测形式</div>
          <div className="p">
            {/* 与元萝卜设备人机对弈，在机器人只有将、士、象{grade === '16' ? '3' : '、卒4'}个棋子的对阵下，对弈战胜机器人 */}
            需要在元萝卜机器人上进行在线评测
          </div>
          <div className="p">按照题目要求进行作答，题目数量：10</div>
          <div className="p">通过标准：完成8道或以上题目的正确作答</div>
        </div>
        <div className="section">
          <div className="h3">3. 评测要求</div>
          <div className="p">
            评测时间为<span>30分钟</span>，若30分钟内没有完成<span>8道及以上</span>
            题目的正确作答，则判定为未通过评测
          </div>
          <div className="p">未通过评测的考生，可以免费重新评测</div>
        </div>
        <div className="section">
          <div className="h3">#注意，请在评测过程中确保：</div>
          <div className="p">机器的网络连接状态良好</div>
          <div className="p">确保棋子齐全和干净</div>
          <div className="p">尽量避免有强光直射棋盘</div>
        </div>
        {from === 'result' ? undefined : (
          <div className="section flex flex-jc">
            <SJCheckbox checked={checked} onChange={(e) => onCheckChange(e)} title="我已阅读并同意">
              <span className="agreement" onClick={() => navigate('/agreement/userinfo')}>
                《用户信息采集须知》
              </span>
            </SJCheckbox>
          </div>
        )}
        <SJSpace height={100} />
      </div>
      {from === 'result' ? undefined : (
        <SJButton
          className="btn-fixed"
          type="primary"
          size="large"
          disabled={disabled || !checked}
          onClick={handleNext}
        >
          {intervalText}
        </SJButton>
      )}
    </div>
  )
}

export default observer(RegistrationNotice)
